import {configurationFile} from "../../config";

const hostname=window.location.hostname;
let environment=  (hostname === 'vendor.fapool.ir' || hostname ==='my.fapool.ir')? 'production':'development';

export const API_URL = configurationFile[environment].API_DOMAIN_NAME;
export const API_URL_V2 = configurationFile[environment].API_DOMAIN_NAME+"v2/";
//export const UPLOAD_URL = configurationFile[environment].DOMAIN_NAME+"storage/public/";
export const UPLOAD_URL = configurationFile[environment].UPLOAD_DOMAIN_NAME;
export const DefaultLang = "fa";
export const DefaultAvatar = "";
